export const preventEsc = (listener: (e?: Event) => void) => (e?: Event) => {
    if (e instanceof KeyboardEvent && e.key === 'Escape') {
        return;
    }

    listener(e);
};
